// Keep index.html's fallback <title> only while no page-level (Helmet) title is present
export const watchFallbackTitle = () => {
  const fallback = document.getElementById('default-title');
  if (!fallback) return;
  const original = fallback.textContent;
  const sync = () => {
    const others = [...document.head.querySelectorAll('title')].some((t) => t !== fallback);
    if (others && fallback.isConnected) fallback.remove();
    else if (!others && !fallback.isConnected) document.head.appendChild(fallback);
  };
  // Pages that write document.title directly change the fallback text; reset it on navigation
  const reset = () => { fallback.textContent = original; };
  const native = window.history.pushState.bind(window.history);
  window.history.pushState = (...args) => { reset(); return native(...args); };
  window.addEventListener('popstate', reset);
  new MutationObserver(sync).observe(document.head, { childList: true });
  sync();
};
